import { createStore } from 'vuex';
import {CustomerProfile} from "@/models/backend/CustomerModels";
import notifications from "@/store/notifications";


export interface State {
    isUserLoggedIn: boolean;
    profile: CustomerProfile | null;
    postalCode: string;
}


export default createStore<State>({
    state: {
        isUserLoggedIn: false,
        profile: null,
        postalCode: ''
    },
    mutations: {
        setUserLoggedIn(state, status: boolean) {
            state.isUserLoggedIn = status
        },
        setProfile(state, profile: CustomerProfile) {
            state.profile = profile
        },


        setPostalCode(state, code: string) {
            state.postalCode = code;
        },

        resetStore(state) {
            state.isUserLoggedIn = false
            state.profile = null
            state.postalCode = ''
        }
    },
    actions: {
        updatePostalCode({ commit }, code: string) {
            commit('setPostalCode', code);
        },
    },
    getters: {
        postalCode: (state) => state.postalCode
    },
    modules:{
        notifications
    }
})

